export default "__VITE_ASSET__Bmt2ih0n__"